// extracted by mini-css-extract-plugin
module.exports = {"image-upload-button":"ImageUploadButton_image-upload-button__3V5Fe"};